import React, { useRef } from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = (props) => {
    const { block, additionalHeaderLinks } = props;
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const overlayElement = useRef(null);

    const toggleMenu = () => {
        Array.from(document.querySelectorAll('.navbar__menu--show')).forEach(
            (item, index) => {
                item.classList.toggle('navbar__menu--show');
            });
        overlayElement.current.classList.toggle('overlay--show');
    }

    return (
        <>
            <div className="overlay" ref={overlayElement} onClick={() => toggleMenu()}></div>
            <NavigationItem links={contentLinks} block={block} additionalHeaderLinks={additionalHeaderLinks} overlayElement={overlayElement} />
        </>
    )
};

export default Navigation;
